import AboutDepartment from "component/shared/about-department/AboutDepartment";

function DataRequestAbout({ servicesTools }) {
  return (
    <div className="col-12 col-lg-4">
      <AboutDepartment
        id="about"
        txt={servicesTools?.about}
        translations={servicesTools?.serviceAndToolTranslation}
      />
    </div>
  );
}

export default DataRequestAbout;
